type PaginatedDataParams<Data> = {
  data: Data[] | undefined
  page: number
  pageSize: number
}

export const getPaginatedData = <Data>({ data, page, pageSize }: PaginatedDataParams<Data>) => {
  if (!data) {
    return data
  }

  const start = page * pageSize
  const end = start + pageSize
  return data.slice(start, end)
}
